import axios from '../../config/axios.js'
import store from '../../vuex/store.js'

const STATE = {

    username: null,
    email: null,
    firstname: null,
    lastname: null,
    created_ts: null,
    role: null,
    status: null,
    language: null,
    memberships: [],
    membership: null,
    is_permanent: false,
    user_type: null,

    payments: [],
    auto_payments: [],

    has_img: 0,
    image_existed: false,
    user_image: null,

    end_date: null,

}

const GETTERS = {

    username: state => state.username,
    email: state => state.email,
    firstname: state => state.firstname,
    lastname: state => state.lastname,
    created_ts: state => state.created_ts,
    role: state => state.role,
    status: state => state.status,
    language: state => state.language,
    memberships: state => state.memberships,
    membership: state => state.membership,
    is_permanent: state => state.is_permanent,
    user_type: state => state.user_type,

    payments: state => state.payments,
    auto_payments: state => state.auto_payments,

    has_img: state => state.has_img,
    image_existed: state => state.image_existed,
    user_image: state => state.user_image,

    end_date: state => state.end_date,
}

const MUTATIONS = {

    getUserInfo(state, user_info) {
        state.username = user_info.username
        state.email = user_info.email
        state.firstname = user_info.firstname
        state.lastname = user_info.lastname
        state.created_ts = user_info.created_ts
        state.role = user_info.role
        state.status = user_info.status
        state.language = user_info.language
        state.payments = user_info.payments
        state.memberships = user_info.memberships
        state.membership = !!user_info.memberships.length ?
            user_info.memberships.slice(-1).pop() : null
        let mem_kind = !!user_info.memberships.length ?
            user_info.memberships.map(v => v.kind).slice(-1).pop() : null
        if (user_info.role == 1 || mem_kind == 3) {
            state.is_permanent = true
        }
        if (user_info.role == 1) {
            state.user_type = 'admin'
        } else if (!!user_info.memberships.length) {
            if (state.membership.kind == 3) {
                state.user_type = 'lifetime'
            } else if ((new Date(state.membership.end_date)).setHours(24, 0, 0, 0) > new Date().getTime()) {
                if (state.membership.kind == 1) {
                    state.user_type = 'trial'
                } else if (state.membership.kind == 2) {
                    state.user_type = 'event'
                } else {
                    state.user_type = 'premium'
                }
            } else {
                state.user_type = 'basic'
            }
        } else {
            state.user_type = 'basic'
        }
        state.has_img = user_info.has_img
        state.end_date = !!state.membership ? state.membership.end_date : null
    },

    getMyPayments(state, payments) {
        state.payments = payments
    },

    getMyAutoPayments(state, payments) {
        // console.log(payments)
        state.auto_payments = payments
    },

    getUserImage(state, payload) {
        state.user_image = payload.image
        state.image_existed = payload.result
    },

    removeUserImage(state) {
        state.user_image = null
        state.image_existed = false
    },

}

const ACTIONS = {

    async getUserInfo({ commit }) {
        await axios.ACCESS.get('/api/user')
            .then(res => {
                // console.log('user/getUserInfo', res)
                if (res.data.result) {
                    commit('getUserInfo', res.data.user)
                } else { throw new Error(res.data) }
            })
    },

    async setUserImage({ commit, dispatch }, form_data) {
        await axios.ACCESS.post('/api/user/image', form_data, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then(res => {
                // console.log('user/setUserImage', res)
                if (res.data.result) {
                    dispatch('getUserImage')
                }
            })
    },

    async updateUserInfo({ commit, dispatch }, payload) {
        await axios.ACCESS.patch('/api/user', {
                firstname: payload.firstname,
                lastname: payload.lastname,
                email: payload.email,
                password: payload.password,
                language: payload.language,
            })
            .then(res => {
                // console.log('user/updateUserInfo', res)
                if (res.data.result) {
                    store.commit('auth/storeAccessToken', res.data.access_token)
                    store.commit('auth/setAccessToken', res.data.access_token)
                    dispatch('getUserInfo')
                } else { throw new Error(res.data) }
            })
    },

    async getMyPayments({ commit }) {
        await axios.ACCESS.get('/api/mypayments')
            .then(res => {
                // console.log('user/getMyPayments', res)
                if (res.data.result) {
                    commit('getMyPayments', res.data.payments)
                } else { throw new Error(res.data) }
            })
    },

    async getMyAutoPayments({ commit }) {
        await axios.ACCESS.get('/api/myautopayments')
            .then(res => {
                // console.log('user/getMyAutoPayments', res)
                if (res.data.result) {
                    commit('getMyAutoPayments', res.data.auto_payments)
                } else { throw new Error(res.data) }
            })
    },

    async getUserImage({ commit }) {
        await axios.ACCESS.get('/api/user/image', {
                responseType: 'arraybuffer',
                headers: { 'Cache-Control': 'no-cache' },
            })
            .then(res => {
                // console.log('user/getUserImage', res)
                let user_image = null
                if (res) {
                    let image = btoa(
                        new Uint8Array(res.data)
                        .reduce((data, byte) => data + String.fromCharCode(byte), '')
                    )
                    user_image = `data:${res.headers['content-type'].toLowerCase()};base64,${image}`
                }
                commit('getUserImage', {
                    image: user_image,
                    result: !!res
                })
            })
    },

    async deleteUserImage({ commit, dispatch }) {
        await axios.ACCESS.delete('/api/user/image')
            .then(res => {
                // console.log('user/deleteUserImage', res)
                commit('removeUserImage')
            })
    },

    async deregister({ dispatch }) {
        await axios.ACCESS.post('/api/deregister')
            .then(res => {
                // console.log('user/deregister', res)
            })
    },

}

export default {
    namespaced: true,
    state: STATE,
    getters: GETTERS,
    mutations: MUTATIONS,
    actions: ACTIONS,
}


// WEBPACK FOOTER //
// ./src/vuex/modules/user.js